import React, {useEffect, useState} from 'react'
import Breadcrumb from 'components/breadcrumb/breadcrumb'
import CoverImg from 'components/General/CoverImg'
import MainTitle from 'components/General/MainTitle'
import { Container } from 'react-bootstrap'
import alger from '../../assets/img/alger.jpg'
import { getLiensUtiles } from 'services/footer'
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser'
import { getAsset } from 'services/assets'
import { ShimmerTitle,ShimmerSimpleGallery,ShimmerPostDetails,ShimmerPostList } from 'react-shimmer-effects';
const LiensUtiles = ({ville}) => {
  const [data, setData] = React.useState();  
  const [loading, setLoading] = React.useState(true);
    useEffect(()=>{
        window.scrollTo({top:0})
        getLiensUtiles().then((x)=>{
            console.log(x)
            var z=x.items[0].data;
            console.log(z)
            setData(z)
            setLoading(false)
          });
      },[])
      const [banner, setBanner] = useState();
useEffect( () => {
  if(data?.banner?.fr)
  getAsset(data?.banner?.fr).then((srcImage)=>{
    setBanner(srcImage);
  });
  
}, [data?.banner?.fr]);
      try{var text = parse(data?.Description?.fr)}catch($){
        text = data?.Description?.fr
      }
  return loading? <ShimmerPostDetails card cta variant="SIMPLE" /> :(
    <>
        <CoverImg img={banner}/>
        <Breadcrumb/>
        <Container>
            <MainTitle>{data?.Titre?.fr??("Liens utiles")}</MainTitle>
            <div>
            <p>
{text}
            </p>
            </div>
        </Container>
    </>
  )
}

export default LiensUtiles